'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _functionTree = require('function-tree');

exports.default = function () {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return new (Function.prototype.bind.apply(_functionTree.Provider, [null].concat(args)))();
};
//# sourceMappingURL=Provider.js.map


//////////////////
// WEBPACK FOOTER
// ./~/cerebral/lib/Provider.js
// module id = 248
// module chunks = 0